import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { PractitionerService } from 'app/core/http/services/practitioner.service'

@Component({
  selector: 'calendar-day-options',
  templateUrl: './calendar-day-options.component.html',
  styleUrls: ['./calendar-day-options.component.scss'],
})
export class CalendarDayOptionsComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<CalendarDayOptionsComponent>,
    private practitionerService: PractitionerService
  ) {}
  selectedOption: 'holiday' | 'blockSchedule' | null = null;
  public practitioner: any;
  public date: string = '';
  public submittedRequest = false;
  public successSubmited = false;

  ngOnInit(): void {
    this.practitioner = this.data.param.practitioner;
    this.date = this.data.param.date;

    if (this.data.param.existingModification) {
      this.selectedOption = this.data.param.existingModification.type;
    }
  }

  save() {
    if (!this.selectedOption) return;

    const newModifiedDay = {
      date: this.date,
      type: this.selectedOption,
    };

    const updatedModifiedDays = [...(this.practitioner.modifiedDays || []), newModifiedDay];

    const practitionerBody = {
      ...this.practitioner,
      modifiedDays: updatedModifiedDays,
    };

    this.practitionerService.updateNew(this.practitioner.practitioner_id, practitionerBody).subscribe({
      next: () => {
        this.submittedRequest = true;
        this.successSubmited = true;

        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(err);
        this.submittedRequest = true;
        this.successSubmited = false;
      },
    });
  }

  remove() {
    const updatedModifiedDays = (this.practitioner.modifiedDays || []).filter((item: any) => !item.date.startsWith(this.date.split('T')[0]));

    const practitionerBody = {
      ...this.practitioner,
      modifiedDays: updatedModifiedDays,
    };

    this.practitionerService.updateNew(this.practitioner.practitioner_id, practitionerBody).subscribe({
      next: () => {
        this.dialogRef.close(true);
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  close() {
    this.dialogRef.close();
  }
}
